export default "__VITE_ASSET__9bb661ff__"